import { Injectable } from '@angular/core';
import { UserService } from '@features/auth/user.service';
import { PersistedOrder } from '@features/orders/persisted-order';
import { SearchHit } from '@features/search/search-hit';
import { first } from 'rxjs/operators';
import { IAsset } from '@imcc/transport';
import { urlToAsset } from '@features/assets/url-to-asset';
import { buildDownload } from './build-download';
import { buildOrderDownload } from './build-order-download';
import { DataLayerService } from './data-layer.service';
import { downloadId } from './download-id';
import { EcommerceEvent } from './ecommerce-event-enum';
import { GtmEvent } from './gtm-event-enum';

@Injectable()
export class DownloadAnalyticsService {
  constructor(private dataLayerService: DataLayerService, private userService: UserService) {}

  trackDirectDownload(
    event: GtmEvent.DirectDownload | GtmEvent.DirectDownloadHighres,
    asset: IAsset | SearchHit,
  ): void {
    this.userService.user$.pipe(first()).subscribe((user) => {
      const { sub: userId } = user || { sub: 'missing' };
      const data = buildDownload(event, asset, downloadId(userId, asset));
      this.dataLayerService.push(event, data);
    });
  }

  trackOrderDownload(order: PersistedOrder): void {
    const data = buildOrderDownload(order);

    this.dataLayerService.push(EcommerceEvent.Purchase, data);
  }

  async trackUrlDownload(url: string): Promise<void> {
    const event = GtmEvent.DirectDownloadHighres;

    return urlToAsset(url).then((asset): void => this.trackDirectDownload(event, asset));
  }
}
